$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: "Wrapper"

  UNSAFE_componentWillMount: ->
    # Trigger a data load
    @props.view.getData?()

  componentDidMount: ->

    node = ReactDOM.findDOMNode(this)

    el = @props.view.render().el

    $(node).append(el)

  render: ->
    return React.createElement 'div', _.pick(@props, [
      'className'
    ])
